import type { AccessRule } from '@/shared/config';
import type { SessionUser, UserRole } from './types';

// Role rules carried over from the production client (nav-data/index.ts, LoginAuthGuard,
// routes/sections/dashboard/frontend.tsx).
export const ADMIN_ROLES: readonly UserRole[] = ['ADMIN', 'SUPERADMIN', 'RPA'];

export const isAdmin = (user: SessionUser | null | undefined) =>
  !!user && ADMIN_ROLES.includes(user.role);

/**
 * WhatsApp-only users (with at least one location) may only use `/whatsapp-logs`.
 * Production's route guard ignored the role while its nav exempted admins; the user form only
 * allows the flag on USER accounts, so exempting admins in both places is equivalent in practice.
 */
export const isWhatsAppOnly = (user: SessionUser | null | undefined) =>
  !!user && !isAdmin(user) && !!user.whatsAppOnly && (user.locations?.length ?? 0) > 0;

export const canConfigureBot = (user: SessionUser | null | undefined) =>
  isAdmin(user) || !!user?.botConfiguration;

export function canAccess(user: SessionUser | null | undefined, rule: AccessRule): boolean {
  if (!user) return false;
  switch (rule) {
    case 'admin':
      return isAdmin(user);
    case 'botConfiguration':
      return canConfigureBot(user);
    default:
      return true;
  }
}
